import state from './state'
import api from './api'

function thousandSeparate(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getButtonEl({count, label, align, saves}) {
  const className = `widget ${count} ${label} ${align}`;
  const countHtml = `<span><em>${saves}</em><i></i><u></u></span>`;

  return `
<div class="${className}">
  <a id="btn">
    ${count === 'none' ? '' : countHtml}
    <b></b>
  </a>
</div>
`;
}

function setAppHtml(el, html) {
  if (el.innerHTML !== html) {
    el.innerHTML = html;
  }
}

function setSaveCount(el, state) {
  setAppHtml(el, getButtonEl(state));
}

function setSaveCountFromApi(el, state) {
  api.getCount(state.url)
  .then(result => thousandSeparate(result.saves))
  .catch(() => '!!!')
  .then(saves => setSaveCount(el, {...state, saves}));
}

export default  () => {
  let onClick = null;
  const appEl = document.getElementById('app');

  setSaveCount(appEl, {...state, saves: '...'});

  if (state.count !== 'none') {
    setSaveCountFromApi(appEl, state);
  }

  appEl.addEventListener('click', () => onClick(), false);

  return {
    onClick(cb) {
      onClick = cb;
    },

    // TODO: Jesh 5/29/19 - re-enable the save increment on popup save window close.
    // increment() {
    //   if (cnt) {
    //     // fade the number out, change it, and then fade it back in
    //     cnt.className = 'fadeOut';
    //     window.setTimeout(() => {
    //       cnt.innerHTML = thousandSeparate(saveCount + 1);
    //       cnt.className = '';
    //     }, 333);
    //   }
    //
    //   if (btnEl) {
    //     btnEl.className = 'saved';
    //   }
    // }
  }
};
